import { PrivilegeLevels } from './roles';
import {
  ChildRoutes,
  FeatureModuleRoutes,
  PseudoModuleRoutes,
} from './constants';
import { Type } from '@angular/core';
import { NavigationItem, NavigationList, NavigationSection } from 'ics-core';
import { ArticleService } from './entity-state/article-service/article.service';
import { IState } from './entity-state/model/state.interface';
import { MaterialRequestService } from './entity-state/material-request-service/material-request.service';
import { TransportPositionService } from './entity-state/transport-position/transport-position.service';
import { _ } from '@ngx-translate/core';

export { AppNavigationItem, AppNavigationSection, APP_NAVIGATION };

interface AppNavigationItem extends NavigationItem {
  stateProvider?: Type<IState<any>>;
}

interface AppNavigationSection extends NavigationSection {
  items: AppNavigationItem[];
}

const coreDataNavigation: AppNavigationSection = {
  label: _('ui.routing.core'),
  authorizations: PrivilegeLevels.ReadAccess,
  link: PseudoModuleRoutes.core,
  items: [
    {
      label: _('ui.routing.article'),
      link: FeatureModuleRoutes.core.article,
      icon: 'category',
      stateProvider: ArticleService,
    },
    {
      label: _('ui.routing.warehouse'),
      link: FeatureModuleRoutes.core.warehouse,
      icon: 'warehouse',
    },
    {
      label: _('ui.routing.handling.unit'),
      link: FeatureModuleRoutes.core.handlingUnit,
      icon: 'pallet',
    },
    {
      label: _('ui.routing.vehicle'),
      link: FeatureModuleRoutes.core.vehicle,
      icon: 'forklift',
    },
    {
      label: _('ui.routing.vehicle.type'),
      link: FeatureModuleRoutes.core.vehicleType,
      icon: 'trolley',
    },
    {
      label: _('ui.routing.transport.type'),
      link: FeatureModuleRoutes.core.transportType,
      icon: { fontSet: 'material-symbols-outlined', name: 'home_storage' },
    },
  ],
};

const lvsNavigation: AppNavigationSection = {
  label: _('ui.routing.lvs'),
  authorizations: PrivilegeLevels.LvsAccess,
  link: PseudoModuleRoutes.lvs,
  items: [
    {
      label: _('ui.routing.storage.area'),
      link: FeatureModuleRoutes.lvs.storageArea,
      icon: { fontSet: 'material-symbols-outlined', name: 'activity_zone' },
    },
    {
      label: _('ui.routing.storage.bin'),
      link: FeatureModuleRoutes.lvs.storageBin,
      icon: 'shelves',
    },
    {
      label: _('ui.routing.requisition'),
      link: FeatureModuleRoutes.lvs.requisition,
      icon: { fontSet: 'material-symbols-outlined', name: 'remove_selection' },
    },
    {
      label: _('ui.routing.inventory'),
      link: FeatureModuleRoutes.lvs.inventory,
      icon: 'inventory_2',
    },
  ],
};

const tmsNavigation: AppNavigationSection = {
  label: _('ui.routing.tms'),
  authorizations: PrivilegeLevels.TmsAccess,
  link: PseudoModuleRoutes.tms,
  items: [
    {
      label: _('ui.routing.transport.position'),
      link: FeatureModuleRoutes.tms.transportPosition,
      icon: { fontSet: 'material-symbols-outlined', name: 'conveyor_belt' },
      stateProvider: TransportPositionService,
    },
    {
      label: _('ui.routing.super.task'),
      link: FeatureModuleRoutes.tms.superTask,
      icon: { fontSet: 'material-symbols-outlined', name: 'select_window' },
    },
    {
      label: _('ui.routing.transport.task.list'),
      link: `${FeatureModuleRoutes.tms.transportTask}/${ChildRoutes.List}`,
      icon: { fontSet: 'material-symbols-outlined', name: 'order_play' },
    },
    {
      label: _('ui.routing.transport.task.history'),
      link: `${FeatureModuleRoutes.tms.transportTask}/${ChildRoutes.History}`,
      icon: { fontSet: 'material-symbols-outlined', name: 'order_approve' },
    },
    {
      label: _('ui.routing.initiator'),
      link: FeatureModuleRoutes.tms.initiator,
      icon: { fontSet: 'material-symbols-outlined', name: 'person_play' },
    },
    {
      label: _('ui.routing.material.request'),
      link: FeatureModuleRoutes.tms.materialRequest,
      icon: { fontSet: 'material-symbols-outlined', name: 'gite' },
      stateProvider: MaterialRequestService,
    },
  ],
};

const adminNavigation: AppNavigationSection = {
  label: _('ui.routing.admin'),
  authorizations: PrivilegeLevels.Admin,
  link: PseudoModuleRoutes.admin,
  items: [
    {
      label: _('ui.routing.user'),
      link: FeatureModuleRoutes.admin.user,
      icon: 'manage_accounts',
    },
    {
      label: _('ui.routing.system.setting'),
      link: FeatureModuleRoutes.admin.systemSettings,
      icon: 'settings',
    },
    {
      label: _('ui.routing.system.log'),
      link: FeatureModuleRoutes.admin.systemLogs,
      icon: 'code',
    },
  ],
};

const APP_NAVIGATION: NavigationList = [
  coreDataNavigation,
  lvsNavigation,
  tmsNavigation,
  adminNavigation,
];
